import React, { useState } from 'react';
import './Menu-View-Accordion.scss';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

const CustomAccordionMenu = (props) => {
  const { category, component, children, getCategoryItems, expanded } = props;
  const [isExpanded, setExpanded] = useState(expanded);

  return (
    <div className='d-flex mx-0 px-0 pt-4'>
      <div className='w-100'>
        <div
          className={`col-md-12 d-flex align-items-center mx-0 pe-4 category-box`}
          onClick={(e) => {
            setExpanded(!isExpanded);
          }}
        >
          <div className='col-md-11 ps-2'>
            <div className='me-3 row'>
              <div className='d-flex col-md-8'>
                <span className='gray-text'>{component} : </span>
                <span className='col-md-9 mx-2'>{category.name}</span>
              </div>
              {component === 'Category' && (
                <div className='justify-content-end col-md-3' align='right'>
                  <span className='items-count-box'>{getCategoryItems(category)} Items</span>
                </div>
              )}
            </div>
          </div>
          <div className='col-md-1 d-flex justify-content-end'>
            {' '}
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </div>
        </div>
        {isExpanded && (
          <div className='col-md-12 mt-1 mx-0 px-2 custom-accordion-body'>{children}</div>
        )}
      </div>
    </div>
  );
};

export default CustomAccordionMenu;
